<template>
  <div>
    <InnovationBalance ref="innovationBalanceRef" />
    <TotalQuoteItems :quote-distribution="quoteDistribution" />
    <AcceptOrRejectAskedQuote @refetchTables="refetchTables" />
  </div>

</template>

<script>
import InnovationBalance from '@/views/components/InnovationBalance.vue'
import AcceptOrRejectAskedQuote from '@/views/components/quote-distribution-components/AcceptOrRejectAskedQuote.vue'
import TotalQuoteItems from '@/views/components/quote-distribution-components/TotalQuoteItems.vue'

export default {
  components: {
    TotalQuoteItems,
    AcceptOrRejectAskedQuote,
    InnovationBalance,
  },
  props: {
    quoteDistribution: {
      type: Object,
      required: true,
    },
  },
  methods: {
    refetchTables() {
      this.$refs.innovationBalanceRef.refetchData()
      this.$emit('refetchQuoteDistributionData')
    },
  },
}
</script>

<style scoped>

</style>
